import type { IncomeSummaryShellProps } from '@/modules/employer/pages/components/IncomeSummaryShell/IncomeSummaryShell.types'

import { IncomeSummary } from '@/components/@Shared/UserManagmentCharts/IncomeSummary/IncomeSummary'

import { useEmployerStatsServiceEmployerStatsControllerGetIncomeStats } from '@/__generated__/queries'

export function IncomeSummaryShell({
  onUpdateChartsData,
}: IncomeSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useEmployerStatsServiceEmployerStatsControllerGetIncomeStats()

  return (
    <IncomeSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
